export interface ResponsiveColumnRule {
    minWidth: number
    columns: number
}

export const defaultResponsiveWaterfallRules: ResponsiveColumnRule[] = [
    { minWidth: 1600, columns: 6 },
    { minWidth: 1300, columns: 5 },
    { minWidth: 1000, columns: 4 },
    { minWidth: 760, columns: 3 },
]

export const getResponsiveWaterfallColumns = (
    width: number,
    rules: ResponsiveColumnRule[] = defaultResponsiveWaterfallRules
) => {
    for (const rule of rules) {
        if (width >= rule.minWidth) {
            return rule.columns
        }
    }

    return 2
}
